export default __webpack_public_path__ + "static/media/safe1.cdfa4ee1.png";